/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_DisabledInputs */

const vi_error_irrigation_disabled = /** @type {(inputs: Error_Irrigation_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tích hợp phun nước SmartLab đang tắt`)
};

/**

* @param {Error_Irrigation_DisabledInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_disabled = /** @type {((inputs?: Error_Irrigation_DisabledInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_DisabledInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_disabled(inputs)
});